import { render, staticRenderFns } from "./diagram-view-canvas.component.vue?vue&type=template&id=458b3efc"
import script from "./diagram-view-canvas.component.ts?vue&type=script&lang=ts&external"
export * from "./diagram-view-canvas.component.ts?vue&type=script&lang=ts&external"
import style0 from "./diagram-view-canvas.component.vue?vue&type=style&index=0&id=458b3efc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports